import PropTypes from 'prop-types'
import dynamic from 'next/dynamic'
import { useRouter } from 'next/router'

import style from './style.module.scss'
import InnerHTML from '@shared/components/InnerHTML'
import { convertDateAMPM, dateCheck } from '@shared/utils'

const PollIcon = dynamic(() => import('@shared-components/ctIcons').then((e) => e.PollIcon))
const MultiPoll = dynamic(() => import('@shared/components/multiPoll'))
const MultiQuiz = dynamic(() => import('@shared/components/multiQuiz'))
const LiveBlogReaction = dynamic(() => import('@shared/components/articleDetail/liveArticle/liveBlogReaction'))

function LiveBlogCard({ data, showShareOption }) {
  const { query } = useRouter()

  const sSlug = `${query?.slug?.join('/')}/?ct-lid=${data?._id}`

  return (
    <div
      className={`${style.liveBox} ${(data?.iPollId || data?.oQuiz?._id) && style.iconBox} pt-3 pt-md-4 ps-3 ps-xxl-4 position-relative`}
      id={data?._id}
    >
      <span className={`${style.date} d-block position-absolute px-1 fst-italic`}>{convertDateAMPM(dateCheck(data?.dPublishDate))} </span>
      {(data?.iPollId || data?.oQuiz?._id) && (
        <div className={`${style.icon} position-absolute`}>
          <PollIcon />
        </div>
      )}
      <div>
        {data?.sTitle && <h3>{data?.sTitle}</h3>}
        {data?.iPollId && (
          <MultiPoll
            className="mb-2"
            data={data?.oPoll}
            // id={data?.iPollId}
          />
        )}
        {data?.oQuiz?._id && (
          <MultiQuiz
            className="mb-1"
            data={data?.oQuiz}
            // id={data?.iPollId}
          />
        )}
        {data?.sContent && <InnerHTML html={data?.sContent} />}
      </div>
      {/* <div className="d-flex align-items-center justify-content-between"> */}
      {/* <div className="text-capitalize">
        <span className="small-text">{t('common:By')}</span>&nbsp;
        <span className="text-primary small-text fw-bold ">{data?.oAuthor?.sFName}</span>
      </div> */}
      {/* {showShareOption && <SocialShare seoData={{ sSlug }} />} */}
      {/* </div> */}
      <LiveBlogReaction sSlug={sSlug} showShareOption={showShareOption} data={data} />
    </div>
  )
}

LiveBlogCard.propTypes = {
  data: PropTypes.object,
  firstElement: PropTypes.number,
  showShareOption: PropTypes.bool
}
export default LiveBlogCard
